module.exports = __webpack_public_path__ + "img/mottocenter-new-logo-white.6c3ae7fa.png";